module.exports = __webpack_public_path__ + "img/bonus.a4df05c.svg";